import { MapItemComponent } from './MapItemComponent';

export const MapItemsComponent = () => {
	return (
		<div className="map-index">
			<div className="wrapper">
				<div className="map-header">
					<h1 className="title">Карты</h1>
					<h2 className="description">Инфографика рынка фондов отвечает на вопросы</h2>
				</div>
				<div className="map-item">
					<MapItemComponent title="Структура рынка" description="Какие фонды доступны?" imgSrcClass="structure" href="/map/structure"></MapItemComponent>
				</div>
				<div className="map-item">
					<MapItemComponent title="Пульс рынка" description="Что сегодня растет?" imgSrcClass="returns" href="/map/returns"></MapItemComponent>
				</div>
				<div className="map-item">
					<MapItemComponent title="Матрица корреляций" description="Что падает вместе?" imgSrcClass="correlation" href="/map/correlation"></MapItemComponent>
				</div>
			</div>
		</div>
	);
}